import DeleteIcon from 'assets/svg/delete/icon-cancel.svg'
import Avatar from 'assets/svg/icon-avatar/ic-avatar.svg'
import RecentIcon from 'assets/svg/recent/icon-recent.svg'
import SearchButtonIcon from 'assets/svg/search/search-white.svg'
import SearchIcon from 'assets/svg/search/search.svg'
import Image from 'common/components/Image'
import Loader from 'common/components/Loader'
import GlobalSearchBar from 'common/components/SearchBar/GlobalSearchBar'
import Skeleton from 'common/components/Skeleton'
import Typography from 'common/components/Typography'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import EscapeRegEx from 'lib/escape-regex'
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import { ISearchHistory } from 'services/Product/stores/models/SearchHistoryModel/interface'
import {
  ItemType,
  VendorType,
} from 'services/Product/stores/models/SearchSuggestionModel/interface'
import searchBarAction from 'services/Search/strategies/search-bar-actions'
import SuggestionContain from 'services/Search/widgets/SuggestionsContent'
import { useStoreActions, useStoreState } from 'stores/hooks'
import styled from 'styled-components'

const Container = styled.div`
  width: ${(props) => (!props.width ? '595px' : props.width)};
  height: 41px;
  position: relative;
`
const SearchBarWrapper = styled.div`
  position: relative;
  display: flex;
  height: auto;
  > div {
    display: inline-block;
    vertical-align: middle;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  input {
    width: 85%;
    margin: 0;
    display: inline-block;
    vertical-align: middle;
    padding: 12px 0px 12px 21px;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border: solid 1px #e8e8e8;
    background-color: ${theme.colors.grayLighter};
  }
  input: focus {
    outline: none;
    border: solid 1px ${theme.colors.orange};
  }
`
const SearchButtonContainer = styled.div`
  width: 15%;
  height: auto;
  background-color: ${theme.colors.orange};
`
const SearchButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  svg {
    margin: 0 auto;
    display: block;
  }
`
const ButtonLoaderWrapper = styled.span`
  margin: 0 auto;
`
const Input = styled.input``

const DeleteWrapper = styled.div`
  width: 12%;
  text-align: right;
`
const DeleteAllItemWrapper = styled.div`
  margin-top: -11px;
`

const StyledIconDelete = styled.div`
  position: relative;
  top: 7px;
`
const SuggestionContainer = styled.div`
  position: absolute;
  z-index: 10000;
  width: calc(100% - 2px);
  height: auto;
  max-height: 450px;
  overflow: scroll;
  border-radius: 6px;
  border: solid 1px ${theme.colors.white};
  background-color: ${theme.colors.white};
  box-shadow: 0 0 20px 0 rgb(134 134 134 / 14%);
  ul {
    padding: 0px;
    margin: 0px;
    margin-bottom: 10px;
  }
  li {
    text-decoration: none;
    list-style: none;
    cursor: pointer;
  }
  ul > p {
    margin-bottom: 10px;
  }
`
const SuggestionsWrapper = styled.div`
  padding: 20px 0px;
  > div {
    margin-bottom: 20px;
  }
`
const SearchResultWrapper = styled.div`
  svg,
  p {
    margin: 0px;
    vertical-align: middle;
    font-size: 13px;
    width: 100%;
  }
  svg {
    width: 13px;
    height: 13px;
    margin-top: 11px;
    margin-right: 10px;
  }
  li {
    line-height: 35px;
    padding-left: 20px;
    padding-right: 20px;
  }
  li: hover {
    background-color: ${theme.colors.grayLighter};
  }
  > p {
    margin-bottom: 5px;
    margin-left: 20px;
  }
`
const SearchDigitalGoodsWrapper = styled.div`
  svg,
  p {
    margin: 0px;
    vertical-align: middle;
    font-size: 13px;
    width: 100%;
  }
  svg {
    width: 22px;
    height: 22px;
    margin-top: 5px;
    margin-right: 10px;
  }
  li {
    line-height: 35px;
    padding-left: 20px;
    padding-right: 20px;
  }
  li: hover {
    background-color: ${theme.colors.grayLighter};
  }
  > p {
    margin-bottom: 5px;
    margin-left: 20px;
  }
`
const StyledListItem = styled.li``

const StyledListItemResult = styled.li`
  background-color: ${(props) =>
    props.isHighlited ? theme.colors.grayLighter : ''};
  display: flex;
`

// TODO : When API Ready Will be Comment Out
// const StyledListPopular = styled.li`
//   background-color: ${(props) =>
//     props.isHighlited ? theme.colors.grayLighter : ''};
//   border: ${(props) =>
//     props.isHighlited
//       ? `solid 1px ${theme.colors.orange}`
//       : `solid 1px ${theme.colors.white}`};
//   border-radius: 5px;
// `

const SellerResultWrapper = styled.div`
  p {
    vertical-align: middle;
    margin-right: 10px;
    font-size: 13px;
  }
  svg {
    margin-top: 8px;
    margin-right: 10px;
  }
  > p {
    margin-bottom: 5px;
    margin-left: 20px;
  }
  li {
    padding-left: 20px;
  }
  li: hover {
    background-color: ${theme.colors.grayLighter};
  }
`
// TODO : When API Ready Will be Comment Out
// const LastSeenWrapper = styled.div`
//   ul {
//     padding-left: 20px;
//   }
//   li {
//     display: inline-block;
//     margin-right: 10px;
//   }
//   li img {
//     width: 60px;
//     height: 60px;
//     padding: 8px;
//     border-radius: 4px;
//   }
//   > p {
//     margin-bottom: 10px;
//     margin-left: 20px;
//   }
// `
const LastSearchWrapper = styled.div`
  > p {
    margin-left: 20px;
  }
  li {
    display: inline-block;
    width: 100%;
    line-height: 35px;
  }
  > p,
  > div {
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 5px;
  }
  li > div {
    display: inline-block;
    vertical-align: middle;
    line-height: 14px;
  }
  li: hover {
    background-color: ${theme.colors.grayLighter};
  }
  li > div:last-child > svg {
    margin-right: 20px;
  }
  li > div:last-child > div {
    margin-right: 13px;
  }
`
const StyledDiv = styled.div`
  width: 80%;
`
const StyledDeleteAll = styled.div`
  cursor: pointer;
`

const PopularSearchWrapper = styled.div`
  ul {
    padding-left: 20px;
  }
  li {
    display: inline-block;
    cursor: pointer;
  }
  ul > p {
    margin-right: 10px;
  }
  > p {
    margin-bottom: 10px;
    margin-left: 20px;
  }
  li {
    width: 130px;
    height: 50px;
  }
`
const StyledSkeletonPopularWrapper = styled.div`
  margin: 0px 10px;
`
const StyledSkeletonPopular = styled(Skeleton)`
  margin-left: 10px;
  display: inline-block;
`
const StyledSkeletonTitlePopular = styled(Skeleton)`
  margin-bottom: 10px;
  margin-left: 20px;
  display: inline-block;
`
// TODO : When API Ready Will be Comment Out
// const PopularCategoriesWrapper = styled.div`
//   > p {
//     margin-bottom: 10px;
//     margin-left: 20px;
//   }
//   ul {
//     display: flex;
//     padding-left: 20px;
//   }
//   li {
//     margin-right: 10px;
//     display: inline-block;
//     width: 75px;
//   }
//   li img {
//     width: 60px;
//     height: 60px;
//     padding: 8px;
//   }
//   li > p {
//     text-align: center;
//   }
// `

const RecentWrapper = styled.div`
  width: 8%;
  svg {
    padding-left: 20px;
  }
`

const Rectangle = styled.div`
  width: 120px;
  height: 40px;
  margin: 0 10px 10px 0;
  border: ${(props) => props.border};
  border-radius: 6px;
  background-color: ${theme.colors.grayLighter};
  p {
    text-align: center;
    padding: 11px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &:hover {
    border: solid 1px ${theme.colors.orange};
  }
`

const StyledSkeleton = styled(Skeleton)`
  margin: 12px 20px 12px 20px;
  display: inline-block;
`
const HighlitedText = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

interface PopularType {
  onItemClick?: Function
  items?: { url: string; text: string }[]
  label?: string
  cursor: number
  startIndex: number
  onMouseOver: Function
}

// eslint-disable-next-line react/display-name
const PopularSearch = React.forwardRef<HTMLDivElement, PopularType>(
  (
    {
      items,
      label,
      onItemClick,
      cursor,
      startIndex,
      onMouseOver,
    }: PopularType,
    ref: React.MutableRefObject<null>,
  ): JSX.Element => {
    return (
      <PopularSearchWrapper>
        <Typography fontSize="13px" fontWeight="bold">
          {label}
        </Typography>
        <ul ref={ref}>
          {items.map((item, index) => {
            return (
              <StyledListItem
                key={String(`search-popular-item-${index}`)}
                onClick={() => onItemClick(item.url)}
                isHighlited={cursor === startIndex + index}
                onMouseOver={onMouseOver}
                data-testid="popular-item-test"
              >
                <Rectangle
                  border={
                    cursor === startIndex + index
                      ? `solid 1px ${theme.colors.orange}`
                      : `solid 1px ${theme.colors.grayLighter}`
                  }
                >
                  <Typography fontSize="13px">{item.text}</Typography>
                </Rectangle>
              </StyledListItem>
            )
          })}
        </ul>
      </PopularSearchWrapper>
    )
  },
)

interface SearchResultsType {
  items?: ItemType[]
  keywords?: string
  label?: string
  startIndex: number
  cursor: number
  onMouseOver: Function
}

// eslint-disable-next-line react/display-name
const SearchResults = React.forwardRef<
  HTMLDivElement,
  SearchResultsType
>(
  (
    {
      items,
      keywords,
      label,
      startIndex,
      cursor,
      onMouseOver,
    }: SearchResultsType,
    ref: React.MutableRefObject<null>,
  ): JSX.Element => {
    const makeBold = (text, key) => {
      const regex = new RegExp(EscapeRegEx(key), 'i')
      return text.replace(regex, `<strong>${key}</strong>`)
    }
    const handleItemClick = (item) => {
      window.location.href = `${WEB_DESKTOP_RALALI_URL}/v/${item.seller_alias}/product/${item.alias}`
    }
    return (
      <SearchResultWrapper>
        <Typography fontSize="13px" fontWeight="bold">
          {label}
        </Typography>
        <ul ref={ref}>
          {items.map((item, index) => {
            return (
              <StyledListItemResult
                key={String(`search-list-item-${index}`)}
                onClick={() => handleItemClick(item)}
                data-testid={`search-result-item-${index}`}
                isHighlited={cursor === startIndex + index}
                onMouseOver={onMouseOver}
              >
                <SearchIcon />
                <HighlitedText
                  dangerouslySetInnerHTML={{
                    __html: makeBold(item.name, keywords),
                  }}
                />
              </StyledListItemResult>
            )
          })}
        </ul>
      </SearchResultWrapper>
    )
  },
)

interface SellerResultsType {
  onItemClick?: Function
  items?: VendorType[]
  keywords?: string
  label?: string
  cursor: number
  startIndex: number
  onMouseOver: Function
}

// eslint-disable-next-line react/display-name
const SellerResults = React.forwardRef<
  HTMLDivElement,
  SellerResultsType
>(
  (
    {
      onItemClick,
      items,
      keywords,
      label,
      cursor,
      startIndex,
      onMouseOver,
    }: SellerResultsType,
    ref: React.MutableRefObject<null>,
  ): JSX.Element => {
    const makeBold = (text, key) => {
      const regex = new RegExp(EscapeRegEx(key), 'i')
      return text.replace(regex, `<strong>${key}</strong>`)
    }
    return (
      <SellerResultWrapper>
        <Typography fontSize="13px" fontWeight="bold">
          {label}
        </Typography>
        <ul ref={ref}>
          {items.map((item, index) => {
            return (
              <StyledListItemResult
                key={String(`search-list-seller-${index}`)}
                onClick={() => onItemClick(item.alias)}
                isHighlited={cursor === startIndex + index}
                onMouseOver={onMouseOver}
              >
                <Avatar />
                <HighlitedText
                  dangerouslySetInnerHTML={{
                    __html: makeBold(item.name, keywords),
                  }}
                />
                {/* TO DO Badge Member */}
                <Image lazy width="16px" height="16px" src="" />
              </StyledListItemResult>
            )
          })}
        </ul>
      </SellerResultWrapper>
    )
  },
)

interface DigitalGoodsType {
  items?: any[]
  keywords?: string
  label?: string
  cursor: number
  onMouseOver: Function
}

// eslint-disable-next-line react/display-name
const DigitalGoods = React.forwardRef<
  HTMLDivElement,
  DigitalGoodsType
>(
  (
    { items, keywords, label, cursor, onMouseOver }: DigitalGoodsType,
    ref: React.MutableRefObject<null>,
  ): JSX.Element => {
    const makeBold = (text, key) => {
      const regex = new RegExp(EscapeRegEx(key), 'i')
      return text.replace(regex, `<strong>${key}</strong>`)
    }
    return (
      <SearchDigitalGoodsWrapper>
        <Typography fontSize="13px" fontWeight="bold">
          {label}
        </Typography>
        <ul ref={ref}>
          {items.map((item, index) => {
            return (
              <StyledListItemResult
                key={String(`search-dg-item-${index}`)}
                onClick={() => {
                  window.location.href = item.link
                }}
                data-test={`search-dg-item-${index}`}
                isHighlited={cursor === index}
                onMouseOver={onMouseOver}
              >
                {item.icon}
                <HighlitedText
                  dangerouslySetInnerHTML={{
                    __html: makeBold(item.title, keywords),
                  }}
                />
              </StyledListItemResult>
            )
          })}
        </ul>
      </SearchDigitalGoodsWrapper>
    )
  },
)

// TODO : When API Ready Will be Comment Out
// interface LastSeenType {
//   label?: string
//   items?: { id: string | number; name: string; image: string }[]
//   onItemClick?: Function
//   onMouseOver: Function
//   cursor: number
// }
//
// eslint-disable-next-line react/display-name
// const LastSeenResults = React.forwardRef<
//   HTMLDivElement,
//   LastSeenType
// >(
//   (
//     { onItemClick, cursor, items, label, onMouseOver }: LastSeenType,
//     ref: React.MutableRefObject<null>,
//   ): JSX.Element => {
//     return (
//       <LastSeenWrapper>
//         <Typography fontSize="13px" fontWeight="bold">
//           {label}
//         </Typography>
//         <ul ref={ref}>
//           {items.map((item, index) => {
//             return (
//               <StyledListItem
//                 data-testid="lastseen-items-test"
//                 key={String(`search-list-last-seen${index}`)}
//                 onClick={onItemClick}
//                 onMouseOver={onMouseOver}
//               >
//                 <Image
//                   lazy
//                   width="106px"
//                   src={item.image}
//                   border={
//                     cursor === index
//                       ? `solid 1px ${theme.colors.orange}`
//                       : `solid 1px ${theme.colors.grayLighter}`
//                   }
//                 />
//               </StyledListItem>
//             )
//           })}
//         </ul>
//       </LastSeenWrapper>
//     )
//   },
// )

// interface PopularCategoriesType {
//   label?: string
//   items?: { id: string | number; name: string; image: string }[]
//   onItemClick?: Function
//   cursor: number
//   startIndex: number
//   onMouseOver: Function
// }

// // eslint-disable-next-line react/display-name
// const PopularCategories = React.forwardRef<
//   HTMLDivElement,
//   PopularCategoriesType
// >(
//   (
//     {
//       onItemClick,
//       items,
//       label,
//       cursor,
//       startIndex,
//       onMouseOver,
//     }: PopularCategoriesType,
//     ref: React.MutableRefObject<null>,
//   ): JSX.Element => {
//     return (
//       <PopularCategoriesWrapper>
//         <Typography fontSize="13px" fontWeight="bold">
//           {label}
//         </Typography>
//         <ul ref={ref}>
//           {items.map((item, index) => {
//             return (
//               <StyledListPopular
//                 key={String(`search-list-last-seen${index}`)}
//                 onClick={onItemClick}
//                 isHighlited={cursor === index + startIndex}
//                 onMouseOver={onMouseOver}
//               >
//                 <Image lazy width="106px" src={item.image} />
//                 <Typography fontSize="10px" fontWeight="bold">
//                   {item.name}
//                 </Typography>
//               </StyledListPopular>
//             )
//           })}
//         </ul>
//       </PopularCategoriesWrapper>
//     )
//   },
// )

interface RecentItemsResultsType {
  label?: string
  items?: ISearchHistory[]
  onItemClick?: Function
  onDeleteAllItem?: Function
  onDeleteItem?: Function
  startIndex: number
  cursor: number
  isLoading: boolean
  onMouseOver: Function
}

// eslint-disable-next-line react/display-name
const RecentItemsResults = React.forwardRef<
  HTMLDivElement,
  RecentItemsResultsType
>(
  (
    {
      onItemClick,
      onDeleteAllItem,
      onDeleteItem,
      items,
      label,
      startIndex,
      cursor,
      onMouseOver,
      isLoading,
    }: RecentItemsResultsType,
    ref: React.MutableRefObject<null>,
  ): JSX.Element => {
    const [activeId, setActiveId] = useState('')

    const deleteItem = (id, key) => {
      if (!isLoading) {
        setActiveId(key)
        onDeleteItem(id)
      }
    }

    const deleteAllItem = () => {
      if (!isLoading) {
        setActiveId('*')
        onDeleteAllItem()
      }
    }
    return (
      <LastSearchWrapper>
        <Typography fontSize="13px" fontWeight="bold">
          {label}
        </Typography>
        {!isLoading || activeId !== '*' ? (
          <StyledDeleteAll
            onClick={deleteAllItem}
            data-testid="delete-all-history"
          >
            <Typography fontSize="10px" fontWeight="bold" color="red">
              Hapus Semua
            </Typography>
          </StyledDeleteAll>
        ) : (
          <DeleteAllItemWrapper>
            <StyledIconDelete>
              <Loader
                radius="50px"
                primaryColor={theme.colors.grayLight}
                secondaryColor={theme.colors.grayLight}
              />
            </StyledIconDelete>
          </DeleteAllItemWrapper>
        )}
        <ul ref={ref}>
          {items.map((item, index) => {
            const key = String(`search-recent-item-${index}`)
            return (
              <StyledListItemResult
                key={key}
                isHighlited={cursor === startIndex + index}
                onMouseOver={onMouseOver}
              >
                <RecentWrapper>
                  <RecentIcon />
                </RecentWrapper>
                <StyledDiv
                  onClick={() => onItemClick(item.keyword)}
                  data-testid={`item-history-${index}`}
                >
                  <Typography>{item.keyword}</Typography>
                </StyledDiv>
                {(!isLoading || activeId !== key) && (
                  <DeleteWrapper
                    onClick={() => deleteItem(item.id, key)}
                    data-testid={`delete-item-history-${index}`}
                  >
                    <DeleteIcon />
                  </DeleteWrapper>
                )}
                {isLoading && activeId === key && (
                  <DeleteWrapper>
                    <Loader
                      radius="50px"
                      primaryColor={theme.colors.grayLight}
                      secondaryColor={theme.colors.grayLight}
                    />
                  </DeleteWrapper>
                )}
              </StyledListItemResult>
            )
          })}
        </ul>
      </LastSearchWrapper>
    )
  },
)

interface SearchType {
  placeHolder?: string
  width?: string
  onItemClick?: Function
  onTyping?: Function
  onOpenOverlay?: Function
  onCloseOverlay?: Function
  isResponsiveEnable?: boolean
  lastSeenItems?: {
    id: string | number
    name: string
    image: string
  }[]
  popularCategories?: {
    id: string | number
    name: string
    image: string
  }[]
}

const RenderInputWithFeatureFlag = ({
  isResponsiveEnable,
  setIsOpenGlobalSearchBar,
  placeHolder,
  onCloseOverlay,
}): JSX.Element => {
  const searchType: 'default' | 'responsive' = isResponsiveEnable
    ? 'responsive'
    : 'default'
  const handleGlobalSearchAction = () => {
    setIsOpenGlobalSearchBar(true)
    onCloseOverlay()
  }
  const action = useCallback(() => {
    return searchBarAction({
      type: searchType,
      defaultAction: handleGlobalSearchAction,
    })
  }, [])

  return (
    <Input
      data-testid="searchbar-input-test"
      onFocus={action}
      placeholder={placeHolder}
    />
  )
}

const SearchLoader = ({
  isLoadingSearch,
}: {
  isLoadingSearch: boolean
}): JSX.Element => {
  if (isLoadingSearch) {
    return (
      <ButtonLoaderWrapper>
        <Loader
          radius="60px"
          primaryColor={theme.colors.white}
          secondaryColor={theme.colors.white}
        />
      </ButtonLoaderWrapper>
    )
  }
  return <SearchButtonIcon />
}

export default function SearchBar({
  width,
  placeHolder = 'Cari produk atau penjual',
  // onItemClick,
  onOpenOverlay = () => null,
  onCloseOverlay = () => null,
  lastSeenItems = [],
  popularCategories = [],
  isResponsiveEnable = false,
  ...otherProps
}: SearchType): JSX.Element {
  const [showSuggestion, setShowSuggestion] = useState(false)
  const [keywords, setKeywords] = useState('')
  const [previousKeywords, setPreviousKeywords] = useState('')
  const [cursor, setCursor] = useState(-1)
  const [listItemSearch, setListItemSearch] = useState([])
  const [billingResult, setBillingResult] = useState([])
  const [isLoadingSearch, setIsLoadingSearch] = useState<boolean>(
    false,
  )
  const [totalSuggestions, setTotalSuggestions] = useState<number>(0)

  const [isOpenGlobalSearchBar, setIsOpenGlobalSearchBar] = useState(
    false,
  )

  const node = useRef<HTMLDivElement>(null)
  const nodeSearchResult = useRef<HTMLDivElement>(null)
  const nodeLastSeen = useRef<HTMLDivElement>(null)
  const nodeRecentItem = useRef<HTMLDivElement>(null)
  const nodePopularSearch = useRef<HTMLDivElement>(null)
  const nodePopularCategories = useRef<HTMLDivElement>(null)
  const nodeSearchSuggestion = useRef<HTMLDivElement>(null)
  const nodeSellerSuggestion = useRef<HTMLDivElement>(null)
  const nodeDigiSuggestion = useRef<HTMLDivElement>(null)
  const nodeSuggestions = useRef<HTMLDivElement>(null)

  const skeletonCount = useCallback((x) => new Array(x).fill(0), [])

  const { getItems, getSuggestion } = useStoreActions(
    (actions) => actions.searchSuggestion,
  )
  const {
    items,
    isLoading,
    isError,
    vendors,
    suggestions,
  } = useStoreState((state) => state.searchSuggestion)
  const { searchPopular, isSearchPopularLoading } = useStoreState(
    (state) => state.searchPopular,
  )

  const { getSearchPopular } = useStoreActions(
    (actions) => actions.searchPopular,
  )

  const {
    itemHistory,
    isLoadingHistory,
    alreadyGetHistory,
  } = useStoreState((state) => state.searchHistory)

  const { getItemHistory, deleteItemHistory } = useStoreActions(
    (actions) => actions.searchHistory,
  )

  const onShowSuggestion = () => {
    setShowSuggestion(true)
    if (searchPopular.length === 0) {
      getSearchPopular()
    }
    if (!alreadyGetHistory) getItemHistory()
  }
  const handleTyping = (e) => {
    setCursor(-1)
    setKeywords(e.target.value.slice(0, 200))
    if (!showSuggestion) {
      setShowSuggestion(true)
    }
  }

  const onSearchClick = () => {
    if (keywords.trim() !== '' && !isLoadingSearch) {
      setIsLoadingSearch(true)
      window.location.assign(
        `${WEB_DESKTOP_RALALI_URL}/search/${keywords}`,
      )
    }
  }

  const handleOutsideClick = (e) => {
    if (node.current.contains(e.target)) {
      return
    }
    setShowSuggestion(false)
    onCloseOverlay()
  }

  const onDeleteHistoryItem = (keywordId) => {
    if (keywordId && !isLoadingHistory) deleteItemHistory(keywordId)
  }

  const onDeleteAllHistoryItem = () => {
    if (!isLoadingHistory) deleteItemHistory('')
  }

  const handleMouseOver = () => {
    setCursor(-1)
  }

  const handleItemPopularClick = (path) => {
    window.location.href = `${WEB_DESKTOP_RALALI_URL}/search/${path}`
  }

  const handleItemHistoryClick = (keyword) => {
    window.location.href = `${WEB_DESKTOP_RALALI_URL}/search/${keyword}`
  }

  const handleSellerClick = (path) => {
    window.location.href = `${WEB_DESKTOP_RALALI_URL}/v/${path}`
  }
  const keyboardNavigation = (event) => {
    const suggestionSellerProduct =
      billingResult.length +
      items.length +
      vendors.length +
      totalSuggestions -
      1

    const recentHistoryPopular =
      lastSeenItems.length +
      itemHistory.length +
      popularCategories.length +
      searchPopular.length -
      1

    const validationKeyboard =
      keywords !== '' ? suggestionSellerProduct : recentHistoryPopular

    if (event.key === 'ArrowDown') {
      setCursor((c) => (c < validationKeyboard ? c + 1 : c))
    } else if (event.key === 'ArrowUp') {
      setCursor((c) => (c >= 0 ? c - 1 : c))
    } else if (event.key === 'Enter') {
      if (keywords.trim() === '') {
        const recentItemsCheck =
          lastSeenItems.length + itemHistory.length
        const searchPopularCheck =
          searchPopular.length + recentItemsCheck
        const popularCategoriesCheck =
          popularCategories.length + searchPopularCheck
        switch (true) {
          case cursor < lastSeenItems.length && cursor >= 0:
            // TO-DO: add enter codition on Last Seen Items
            break

          case cursor >= lastSeenItems.length &&
            cursor < recentItemsCheck:
            window.location.href = `${WEB_DESKTOP_RALALI_URL}/search/${
              itemHistory[cursor - lastSeenItems.length].keyword
            }`
            break

          case cursor >= recentItemsCheck &&
            cursor < searchPopularCheck:
            window.location.href = `${WEB_DESKTOP_RALALI_URL}/search/${
              searchPopular[cursor - recentItemsCheck].url
            }`
            break

          case cursor >= searchPopularCheck &&
            cursor < popularCategoriesCheck:
            // TO-DO: add enter codition on Popular Categories
            break

          default:
            break
        }
      } else {
        switch (true) {
          case cursor < billingResult.length && cursor >= 0:
            window.location.href = billingResult[cursor].link
            break

          case cursor >= billingResult.length &&
            cursor < billingResult.length + items.length:
            window.location.href = `${WEB_DESKTOP_RALALI_URL}/v/${items[cursor].microsite_url}/product/${items[cursor].alias}`
            break

          case cursor >= items.length + billingResult.length &&
            cursor <
              items.length + vendors.length + billingResult.length:
            window.location.href = `${WEB_DESKTOP_RALALI_URL}/v/${
              vendors[cursor - items.length].alias
            }`
            break

          default:
            if (!isLoadingSearch) {
              setIsLoadingSearch(true)
              if (listItemSearch[cursor]) {
                listItemSearch[cursor].click()
                break
              }
              window.location.assign(
                `${WEB_DESKTOP_RALALI_URL}/search/${keywords}`,
              )
            }
            break
        }
      }
      onCloseOverlay()
    }
  }

  const scrollIntoView = (position) => {
    nodeSearchResult.current.scrollTo({
      top: position,
      behavior: 'smooth',
    })
  }

  // eslint-disable-next-line consistent-return
  const getSuggestionSearchItems = (currentNode) => {
    let itemsArray = []
    if (currentNode) {
      for (let index = 0; index < currentNode.length; index += 1) {
        const currentNodeChild = Array.from(
          currentNode[index].children[1].children,
        )
        itemsArray = [...itemsArray, ...currentNodeChild]
      }
      return itemsArray
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        keywords.trim() !== '' &&
        keywords !== previousKeywords &&
        !isLoading
      ) {
        setBillingResult([])
        getSuggestion(keywords)
        setPreviousKeywords(keywords)
        setShowSuggestion(true)
      }
    }, 500)
    if (
      vendors.length === 0 &&
      items.length === 0 &&
      billingResult.length === 0 &&
      totalSuggestions === 0 &&
      !isLoading &&
      keywords.trim() !== ''
    ) {
      setShowSuggestion(false)
    }
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getSuggestion,
    getItems,
    keywords,
    showSuggestion,
    items,
    vendors,
    billingResult,
    isLoading,
    totalSuggestions,
  ])

  useEffect(() => {
    if (showSuggestion) {
      // eslint-disable-next-line no-unused-expressions
      onCloseOverlay()
      document.addEventListener('mousedown', handleOutsideClick)
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [showSuggestion, onOpenOverlay])

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (nodeSearchResult && showSuggestion) {
      if (keywords.trim() !== '') {
        const timer = setTimeout(() => {
          const digitalSearch = nodeDigiSuggestion.current
            ? Array.from(nodeDigiSuggestion.current.children)
            : []
          const suggestSearch = nodeSearchSuggestion.current
            ? Array.from(nodeSearchSuggestion.current.children)
            : []
          const suggestSeller = nodeSellerSuggestion.current
            ? Array.from(nodeSellerSuggestion.current.children)
            : []
          const suggestionSearch = nodeSuggestions.current
            ? getSuggestionSearchItems(
                nodeSuggestions.current.children,
              )
            : []
          setListItemSearch(
            digitalSearch.concat(
              suggestSearch,
              suggestSeller,
              suggestionSearch,
            ),
          )
        }, 500)
        return () => clearTimeout(timer)
      }
      const LastSeen = nodeLastSeen.current
        ? Array.from(nodeLastSeen.current.children)
        : []
      const RecentItem = nodeRecentItem.current
        ? Array.from(nodeRecentItem.current.children)
        : []
      const PopularSearchItems = nodePopularSearch.current
        ? Array.from(nodePopularSearch.current.children)
        : []
      const PopularCategoriesItems = nodePopularCategories.current
        ? Array.from(nodePopularCategories.current.children)
        : []

      setListItemSearch(
        LastSeen.concat(
          RecentItem,
          PopularSearchItems,
          PopularCategoriesItems,
        ),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    items,
    billingResult,
    itemHistory,
    searchPopular,
    // lastSeenItems,
    vendors,
    // popularCategories,
    keywords,
    totalSuggestions,
  ])

  useEffect(() => {
    if (
      cursor >= 0 &&
      (nodeSearchResult || nodeSuggestions) &&
      showSuggestion
    ) {
      if (listItemSearch[cursor] !== undefined) {
        scrollIntoView(listItemSearch[cursor].offsetTop - 80)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cursor, showSuggestion])

  const SuggestionSection = () => {
    return showSuggestion ? (
      <SuggestionContainer
        ref={nodeSearchResult}
        data-testid="searchbar-suggestion-test"
      >
        <SuggestionsWrapper>
          {keywords === '' ? (
            <>
              {isLoadingHistory && itemHistory.length === 0 && (
                <StyledSkeleton height="32px" width="93%" />
              )}
              {itemHistory.length > 0 ? (
                <RecentItemsResults
                  data-testid="searchbar-recent-items-test"
                  items={itemHistory}
                  onItemClick={handleItemHistoryClick}
                  onDeleteAllItem={onDeleteAllHistoryItem}
                  onDeleteItem={onDeleteHistoryItem}
                  startIndex={lastSeenItems.length}
                  cursor={cursor}
                  ref={nodeRecentItem}
                  label="Pencarian Terakhir"
                  onMouseOver={handleMouseOver}
                  isLoading={isLoadingHistory}
                />
              ) : null}
              {isSearchPopularLoading && (
                <div>
                  <div>
                    <StyledSkeletonTitlePopular
                      width="125px"
                      height="18px"
                    />
                  </div>
                  <StyledSkeletonPopularWrapper>
                    {skeletonCount(6).map((_, idx) => (
                      <StyledSkeletonPopular
                        // eslint-disable-next-line react/no-array-index-key
                        key={idx}
                        width="120px"
                        height="40px"
                      />
                    ))}
                  </StyledSkeletonPopularWrapper>
                </div>
              )}
              {searchPopular.length > 0 && !isError ? (
                <PopularSearch
                  data-testid="searchbar-items-popular-test"
                  items={searchPopular}
                  onItemClick={handleItemPopularClick}
                  label="Pencarian Populer"
                  cursor={cursor}
                  ref={nodePopularSearch}
                  startIndex={
                    lastSeenItems.length + itemHistory.length
                  }
                  onMouseOver={handleMouseOver}
                />
              ) : null}
            </>
          ) : (
            <>
              {billingResult.length > 0 ? (
                <DigitalGoods
                  data-testid="searchbar-results-list-test"
                  items={billingResult}
                  keywords={keywords}
                  label="R-Billing"
                  cursor={cursor}
                  ref={nodeDigiSuggestion}
                  onMouseOver={handleMouseOver}
                />
              ) : null}
              {isLoading && (
                <StyledSkeleton height="32px" width="93%" />
              )}
              {items.length > 0 && !isError ? (
                <SearchResults
                  data-testid="searchbar-results-list-test"
                  items={items}
                  keywords={keywords}
                  label="Pencarian"
                  startIndex={billingResult.length}
                  cursor={cursor}
                  ref={nodeSearchSuggestion}
                  onMouseOver={handleMouseOver}
                />
              ) : null}
              {vendors.length > 0 ? (
                <SellerResults
                  data-testid="searchbar-results-list-test"
                  items={vendors}
                  onItemClick={handleSellerClick}
                  keywords={keywords}
                  cursor={cursor}
                  startIndex={items.length + billingResult.length}
                  label="Penjual"
                  ref={nodeSellerSuggestion}
                  onMouseOver={handleMouseOver}
                />
              ) : null}
              <SuggestionContain
                suggestions={suggestions}
                keywords={keywords}
                cursor={cursor}
                setTotalSuggestions={setTotalSuggestions}
                ref={nodeSuggestions}
              />
            </>
          )}
        </SuggestionsWrapper>
      </SuggestionContainer>
    ) : null
  }

  return (
    <Container
      width={width}
      data-testid="searchbar-test"
      ref={node}
      {...otherProps}
    >
      <SearchBarWrapper>
        <RenderInputWithFeatureFlag
          setIsOpenGlobalSearchBar={setIsOpenGlobalSearchBar}
          placeHolder={placeHolder}
          onCloseOverlay={onCloseOverlay}
          isResponsiveEnable={isResponsiveEnable}
        />

        <SearchButtonContainer>
          <SearchButtonWrapper
            data-testid="searchbar-button-click-test"
            onClick={onSearchClick}
          >
            <SearchLoader isLoadingSearch={isLoadingSearch} />
          </SearchButtonWrapper>
        </SearchButtonContainer>
      </SearchBarWrapper>

      <GlobalSearchBar
        isOpen={isOpenGlobalSearchBar}
        setIsOpen={setIsOpenGlobalSearchBar}
        handleTyping={handleTyping}
        keywords={keywords}
        onShowSuggestion={onShowSuggestion}
        keyboardNavigation={keyboardNavigation}
        isLoadingSearch={isLoadingSearch}
        onSearchClick={onSearchClick}
      >
        <SuggestionSection />
      </GlobalSearchBar>
    </Container>
  )
}
